import React from 'react';

// Lightweight, non-fixed loader for the brief moment before the wall data
// arrives. The real page uses #preloader (position: fixed) which is fine inside
// an iframe but would cover the host page here, so we reuse the .spinner-loader
// rule that already ships in loader.css.
export default function EmbedLoader() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '40px 16px',
      }}
    >
      <span className="spinner-loader" />
    </div>
  );
}
